export const OFFLINE_AUDIT_EVENTS_KEY = 'offline-audit-events'
export const MAX_OFFLINE_AUDIT_EVENTS = 750

const safeObject = value => (value && typeof value === 'object' ? value : {})

export const normalizeOfflineAuditEvents = (events = []) => {
  return Array.isArray(events)
    ? events
      .filter(event => event && event.id && event.event && event.occurred_at)
      .sort((a, b) => String(b.occurred_at).localeCompare(String(a.occurred_at)))
      .slice(0, MAX_OFFLINE_AUDIT_EVENTS)
    : []
}

export const buildOfflineAuditEvent = (payload = {}, context = {}) => {
  const now = new Date().toISOString()
  const authUser = safeObject(context.authUser)
  const system = safeObject(context.system)
  const route = safeObject(context.route)

  return {
    id: payload.id || `${now}-${Math.random().toString(36).slice(2, 10)}`,
    event: payload.event || 'offline_audit_event',
    severity: payload.severity || 'info',
    source: payload.source || 'client',
    occurred_at: payload.occurred_at || now,
    online: typeof payload.online === 'boolean' ? payload.online : Boolean(context.online),
    water_year: payload.water_year || system.waterYear || null,
    user_id: payload.user_id || authUser.id || null,
    user_name: payload.user_name || authUser.full_name || authUser.name || null,
    route: payload.route || route.fullPath || route.path || null,
    details: safeObject(payload.details)
  }
}

export const persistOfflineAuditEvents = async (localForage, events = []) => {
  const normalized = normalizeOfflineAuditEvents(events)
  await localForage.setItem(OFFLINE_AUDIT_EVENTS_KEY, normalized)
  return normalized
}

export const hydrateOfflineAuditEvents = async (localForage) => {
  const events = await localForage.getItem(OFFLINE_AUDIT_EVENTS_KEY)
  return normalizeOfflineAuditEvents(events)
}
